import BaseService from "./BaseService";

export default class ChannelService extends BaseService {
  constructor() {
    super();
  }

  async getChannels() {
      const result = await super.callApi(
        `MapEventChannel/${window.redseats.eventKey}`,
        "Get"
      );
      if (result.statusCode == "201") {
        return result.data;
      } else return super.htmlError(result.errorMessage);
  }

  async saveChannels(channels: any) {
    const body = {
      EventId: window.redseats.eventKey,
      Channels: channels
    };
    const result = await super.callApi(
      "MapEventChannel",
      "Post",
      body
    );
    if (result.statusCode == "201") {
      return result.data;
    } else return super.htmlError(result.errorMessage);
}

async changeSeatChannels(channels: any) {
  const result = await super.callApi(
    `MapEventSeatChannel`,
    "Post",
    channels,
  );

  if (result.statusCode != "200") return false;

  return result.data[0].statusCode == "200";
}
}
